import { useParams } from "react-router";
import { useSingleMission_she } from "../../actions/homeActions";
import { useState } from "react";
import localimgpath from "../../js/localimgpath";
export default () => {
  const { id } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const {
    data: missionSHE,
    isLoading,
    isError,
    error,
  } = useSingleMission_she(id);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Mission SHE: {error.message}
        </p>
      </div>
    );
  }
  const galleryImages = missionSHE?.galleries?.map((item) => ({
    original: `${localimgpath?.mission_sheGallery}/${item?.image}`,
    thumbnail: `${localimgpath?.mission_sheGallery}/${item?.image}`,
    originalAlt: item?.title || "Gallery Image",
    description: item?.title || "",
  }));
  const openGallery = (index) => {
    setSelectedIndex(index);
    setIsOpen(true);
  };

  const closeGallery = () => setIsOpen(false);
  return {
    isLoading,
    missionSHE,
    openGallery,
    isOpen,
    closeGallery,
    selectedIndex,
    galleryImages,
    localimgpath,
  };
};
